module.exports = __webpack_public_path__ + "img/1525987370.d7696029.jpg";